import { useState, useRef, useCallback, MutableRefObject } from 'react';

export type UseBaseFlowResult<T = object> = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  callback: MutableRefObject<() => void>;
  data: T;
  setData: (obj: T) => void;
  dispatchNextFlowEvent?: () => void;
};

export type FlowContextProps = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const useBaseFlow = <T extends object>(): UseBaseFlowResult<T> => {
  const [isOpen, setOpen] = useState(false);
  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const open = useCallback(() => {
    setOpen(true);
  }, []);

  const callback = useRef(() => {});

  const [data, setData] = useState<T>({} as T);

  const setDataCustom = (values: T): void => {
    setData((state) => ({ ...state, ...values }));
  };

  return { isOpen, open, close, callback, data, setData: setDataCustom };
};

export { useBaseFlow };
